// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@awc/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import ChevronRight from "@awc/XDL/Icons/ChevronRight";
import { css } from "styled-components";

imageStyles.container = {
    gap: 5,
    css: css`
        padding: 16px 32px;
    `,
};

imageStyles.productButton = {
    variant: "tertiary",
    icon: { src: ChevronRight, position: "right" },
};

imageStyles.imageMissingText = {
    variant: "h3",
    css: css`
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        text-align: center;
    `,
    ...{ as: "h2" },
};
